import { render, staticRenderFns } from "./rolePowerConfig.vue?vue&type=template&id=6ddd7748&scoped=true"
import script from "./rolePowerConfig.vue?vue&type=script&lang=js"
export * from "./rolePowerConfig.vue?vue&type=script&lang=js"
import style0 from "./rolePowerConfig.vue?vue&type=style&index=0&id=6ddd7748&prod&lang=scss"
import style1 from "./rolePowerConfig.vue?vue&type=style&index=1&id=6ddd7748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd7748",
  null
  
)

export default component.exports